import { useParams } from "react-router";
import { useApiGet } from "../../utils/api";
import { TripModal } from "./trip_modal";
import { useModal } from "../../utils/modal_launcher";
import { formatDate } from "../../utils/helpers";
import { Calendar } from "./calendar";
import IdeaBoard from "./idea_board";
import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

export const UserTrip = () => {
  const { id } = useParams();
  const { data, unavailable } = useApiGet({ trip: `/api/user/trip/${id}` });
  const tripModal = useModal(TripModal, { id });
  const [activeTab, setActiveTab] = useState<"calendar" | "ideas">("calendar");

  if (unavailable) {
    return unavailable;
  }

  const trip = data?.trip || {};

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="fs-30">{trip.name}</div>
        <button
          className="btn btn-link p-0 fs-22 gray-3"
          onClick={() => tripModal.show({})}
        >
          <i className="bi bi-gear-fill" />
        </button>
      </div>
      <div className="mt-2 fs-18">
        {formatDate(trip.from)} - {formatDate(trip.to)}
      </div>
      <Tabs
        id="user-trip-tabs"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k as "calendar" | "ideas")}
        className="mt-4"
        mountOnEnter
      >
        <Tab eventKey="calendar" title="Calendar" className="pt-3">
          <Calendar trip={trip} />
        </Tab>
        <Tab eventKey="ideas" title="Ideas" className="pt-4">
          <IdeaBoard trip={trip} />
        </Tab>
      </Tabs>
    </div>
  );
};
